import { render } from "./RequiredDocument.vue?vue&type=template&id=cd29186a&ts=true"
import script from "./RequiredDocument.vue?vue&type=script&lang=ts"
export * from "./RequiredDocument.vue?vue&type=script&lang=ts"

import "./RequiredDocument.vue?vue&type=style&index=0&id=cd29186a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__